<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4"
        class="flex-column justify-space-between position-relative"
        :class="[isOpenedLeftSide ? 'd-flex' : 'd-none']"
      >
        <ProjectsList
          v-model="selectedTasksAndFolders"
          :updateProjectsList="updateProjectsList"
          :redirectedProject="redirectedProject"
          :redirectedClient="redirectedClient"
          @projectsListUpdated="onProjectListUpdated"
          @addReporting="addReporting"
          @changeFilterClosedFoldersTasks="filterClosedFoldersTasks = $event"
          @getReportsOnRedirect="getReportsOnRedirect"
        />
        <EmployeeList
          v-model="selectedEmployee"
          :redirectedEmployee="redirectedEmployee"
          @getReportsOnRedirect="getReportsOnRedirect"
        />
      </v-col>
      <v-col cols="12" :md="isOpenedLeftSide ? 8 : 12" class="position-relative">
        <v-btn color="primary"
          icon
          class="toggle-left-side-btn"
          :class="{'forward-btn': !isOpenedLeftSide}"
          @click="isOpenedLeftSide = !isOpenedLeftSide"
        >
          <v-icon>{{ isOpenedLeftSide ? 'mdi-backburger' : 'mdi-forwardburger' }}</v-icon>
        </v-btn>
        <ReportsList
          v-model="reportsData"
          ref="reportsRef"
          @reportingWasAdded="reportingFor = null"
          :addReportingFor="reportingFor"
          :refreshResultsKey="refreshReportsGrid"
          :filterClosedFoldersTasks="filterClosedFoldersTasks"
          :isRedirected="isRedirected"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'ManagerReports',
  components: {
    ProjectsList: () => import('@/components/manager_reports/ProjectsList.vue'),
    ReportsList: () => import('@/components/manager_reports/ReportsList.vue'),
    EmployeeList: () => import('@/components/manager_reports/EmployeeList.vue')
  },
  data () {
    return {
      updateKey: 0,
      selectedTasksAndFolders: {},
      selectedEmployee: {},
      filterClosedFoldersTasks: false,
      loading: false,
      search: '',
      selects: [],
      updateProjectsList: null,
      reportingFor: null,
      isOpenedLeftSide: true,
      refreshReportsGrid: 0,
      redirectedProject: null,
      redirectedEmployee: null,
      redirectedClient: null
    }
  },
  mounted () {
    if (this.$route.params.Project_ID) {
      this.redirectedProject = this.$route.params.Project_ID
    } else if (this.$route.params.Employee_ID) {
      this.redirectedEmployee = this.$route.params.Employee_ID
    } else if (this.$route.params.Client_ID) {
      this.redirectedClient = this.$route.params.Client_ID
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    reportsData () {
      return {
        ...this.selectedTasksAndFolders,
        ...this.selectedEmployee
      }
    },
    isRedirected () {
      return this.$route.params.Project_ID || this.$route.params.Employee_ID || this.$route.params.Client_ID
    }
  },
  methods: {
    onProjectListUpdated () {
      this.updateProjectsList = null
      ++this.refreshReportsGrid
    },
    addReporting (item) {
      this.reportingFor = { ...item }
    },
    getReportsOnRedirect () {
      this.$refs.reportsRef.getRedirectedReports()
    }
  }
}
</script>

<style lang="scss">
  .position-relative {
    position: relative;
  }
  .toggle-left-side-btn {
    position: absolute;
    top: 15px;
    left: 0;
    transform: translate(-50%, -30%);
    z-index: 3;
    &.forward-btn {
      transform: translate(10%, -30%);
    }
  }
</style>
